import { InjectionToken } from '@angular/core';
import { Datos} from './overlayLoaderConfig';
export const PREVIEW_DIALOG_DATA = new InjectionToken<Datos>('PREVIEW_DIALOG_DATA');
